import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectCPMFTrackingForecastChartType,
  selectCPMFTrackingForecastSubpage,
  setChartType,
  setSubpage,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { store } from 'redux/store';
import type { ChartType } from 'types/Meteorology/TrackingForecast';
import { Subpage, SUBPAGE_NAMES } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useControls() {
  const currentSubpage = useSelector(selectCPMFTrackingForecastSubpage);
  const subpageButtonProps = useMemo(() => Object.keys(SUBPAGE_NAMES).map((subpage) => ({
    text: SUBPAGE_NAMES[subpage],
    onClick: () => { store.dispatch(setSubpage(subpage as Subpage)); },
    active: currentSubpage === subpage,
  })), [currentSubpage]);
  const chartMode: ChartType = useSelector(selectCPMFTrackingForecastChartType);
  const setChartMode = useCallback((v: ChartType) => {
    store.dispatch(setChartType(v));
  }, []);

  return {
    subpageButtonProps,
    chartMode,
    setChartMode,
  };
}
